import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function TurnLeftIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 13, 13);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 13 13" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M12.5 12.5V11.45C12.5 8.92976 12.5 7.66965 12.0095 6.70704C11.5781 5.86031 10.8897 5.1719 10.043 4.74047C9.08035 4.25 7.82024 4.25 5.3 4.25H0.5M0.5 4.25L4.25 8M0.5 4.25L4.25 0.5" /></svg>
  );
}

export default TurnLeftIcon;